import script from "./App-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./App-Main.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__